export const MerchantListStyles = {
  loadingContainer: (loadMoreButtonDisplayed: boolean = false) =>
    `flex flex-col justify-center ${
      !loadMoreButtonDisplayed ? 'mb-12 mt-14' : ''
    } px-12`,
  listContainer: 'flex flex-row justify-center flex-wrap w-11/12 mb-10',
  loadMoreButton: 'my-10 px-12',
}
